import { render, staticRenderFns } from "./UpdateCorporate.vue?vue&type=template&id=bb0488ec&"
import script from "./UpdateCorporate.vue?vue&type=script&lang=js&"
export * from "./UpdateCorporate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports